import React from 'react';

import { faComments } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PriceMatrix from 'pu-react/components/PriceMatrix';
import PriceMatrixCell from 'shared/product_tabs/tab_assembly/components/price/mx/PriceMatrixCell';
import HowItWorks from 'shared/product_tabs/tab_assembly/components/price/mx/HowItWorks';

const Prices = (props) => {
  const {
    parameters,
    quote,
    quoteStep,
    parametersChanged,
    onPriceSelect,
    onSendEmailQuote,
    toggleHowItWorks,
  } = props;

  const lineItem = quote.line_items && quote.line_items.find((li) => li.product_key === 'assembly-mx');
  const restricted_price = lineItem.restricted_price;

  return <>
    <div className="price-matrices">
      <div className="price-matrix mx-matrix">
        <div className="d-flex justify-content-between my-2">
          <h2 className="title text-uppercase d-inline-block">Mexico Pcb Assembly</h2>
        </div>
        <PriceMatrix
          tableSm
          tableStripe={false}
          lineItem={lineItem}
          quote={quote}
          matrixCell={PriceMatrixCell}
          leadTimeText={(lt) => `${lt} weeks`}
          parametersChanged={parametersChanged}
          onPriceSelect={onPriceSelect}
          parameters={parameters}
          quoteStep={quoteStep}
          restricted_price={restricted_price} />
        <div>
          <p className="mb-0">
            <FontAwesomeIcon icon={faComments} id="custom-quote-icon" />
            &nbsp; If you could not get an online price you can request a &nbsp;
            <a className="link" href={Spree.routes.custom_quote_request_new_url}>custom quote</a>.
          </p>
          <ul>
            <li>First Article cost is included (Lead Time = 2 to 3 weeks).</li>
            <li>Production Lead Time starts after First Article is approved.</li>
            <li>To return the leftover parts and SMT Stencil, an additional customs fee (~$500.00) will be applied.</li>
          </ul>
        </div>
      </div>
    </div>
    <div>
      <HowItWorks toggle={toggleHowItWorks} />
    </div>
  </>
}

export default Prices;